import {lazy, Suspense} from 'react'
import {Routes, Route, useNavigate} from 'react-router-dom'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
`

const Content = styled.div`
  display: flex;
  flex: 1;
`

const Index = () => {
  const List = lazy(() => import('./List'))
  const Regis = lazy(() => import('./Regis'))
  const Jaego = lazy(() => import('./Jaego'))

  return (
    <Container>
      <Content>
        <Suspense fallback={''}>
          <Routes>
            {['/', '/:pageNum'].map((path, index) => (
              <Route
                key={index}
                path={path}
                element={<List/>}
              />
            ))}

            {['/regis', '/regis/:id'].map((path, index) => (
              <Route
                key={index}
                path={path}
                element={<Regis/>}
              />
            ))}

            {['/jaego', '/jaego/:id' , '/jaego/:id/:pageNum'].map((path, index) => (
              <Route
                key={index}
                path={path}
                element={<Jaego/>}
              />
            ))}
          </Routes>
        </Suspense>
      </Content>
    </Container>
  )
}

export default Index
